<template>
  <div
    ref="videoWrap"
    class="videoWrap"
  >
    <div
      :id="videoDomId"
      class="videoWrapper"
    ></div>
    <ControlWrapping
      v-if="player"
      :player="player"
      :start-record="startRecord"
      :full-screen="fullScreen"
      @control="control"
      @fullScreen="fullScreenRequest"
    />
    <CloudControl ref="CloudControl" />
  </div>
</template>

<script>
import EZUIKit from 'ezuikit-js'
import ControlWrapping from './ControlWrapping.vue'
import CloudControl from './CloudControl.vue'
import screenfull from 'screenfull'
import { nanoid } from 'nanoid'
export default {
  components: { ControlWrapping, CloudControl },
  props: {
    playType: {
      type: Number,
      default: 1
    },
    url: {
      type: String,
      default: 'player'
    },
    accessToken: {
      type: String,
      default: 'player'
    },
    dataItem: {
      type: Object,
      default: () => { return {} }
    },
    videoStyle: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      player: null,
      startRecord: false,
      fullScreen: false,
      videoDomId: nanoid()
    }
  },
  watch: {
    url: {
      immediate: true,
      handler(val) {
        console.log('EZVideo', val)
        if (val) {
          if (this.player) {
            setTimeout(() => {
              this.player.play(val)
            }, 500)
          } else {
            this.$nextTick(() => {
              this.initVideo()
            })
          }
        }
      }
    }
  },
  created() {
    screenfull.on('change', this.onScreenFull)
  },
  mounted() {

  },
  destroyed() {
    screenfull.off('change', this.onScreenFull)
  },
  methods: {
    onScreenFull() {
      this.fullScreen = screenfull.isFullscreen
    },
    initVideo() {
      const option = {
        id: this.videoDomId, // 视频容器ID
        accessToken: this.accessToken,
        url: this.url,
        autoplay: true,
        handleError: this.handleError,
        audio: 0, // 是否默认开启声音 0 - 关闭 1 - 开启
        template: 'simple', // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
        startSaveCallBack: this.startSaveCallBack,
        stopSaveCallBack: this.stopSaveCallBack,
        capturePictureCallBack: this.capturePictureCallBack
      }
      if (this.videoStyle) {
        option.width = this.videoStyle.width
        option.height = this.videoStyle.height
      }
      this.player = new EZUIKit.EZUIKitPlayer(option)
      // this.player.play()
    },
    startSaveCallBack(e) {
      console.log(e)
      this.startRecord = true
    },
    stopSaveCallBack(e) {
      console.log(e)
      this.startRecord = false
    },
    capturePictureCallBack(e) {
      console.log(e)
    },
    control() {
      console.log(this.dataItem)
      this.$refs.CloudControl.init(this.dataItem)
    },
    fullScreenRequest() {
      if (this.fullScreen) {
        if (screenfull.enabled) {
          screenfull.exit()
        }
      } else {
        if (screenfull.enabled) {
          screenfull.request(this.$refs.videoWrap)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#video-container{
    width: 100% !important;
    height: 100% !important;
}
.videoWrap{
  position: relative;
  width: 100%;
  height: 100%;

}
.videoWrapper{
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}
</style>

